import React, { FC, useCallback, useEffect, useRef } from "react";
import { AspectRatio } from "@chakra-ui/react";
import { Player, ControlBar } from 'video-react';
import { useStore } from "../store";

const HEIGHT = 526;

type VideoProps = {
  media: string
  thumbnail: string
}

const Video: FC<VideoProps> = ({
  media,
  thumbnail,
}) => {
  const isGalleryMode = useStore((state) => state.isGalleryMode);
  const isVideoPlaying = useStore((state) => state.isVideoPlaying);
  const { height } = useStore((state) => state.windowDimensions)
  const setIsVideoPlaying = useStore((state) => state.setIsVideoPlaying);

  const videoRef = useRef<any>(null);

  const handleVideo = useCallback(async  (mode: 'start' | 'stop') => {
    if(!videoRef.current){
      return
    }
    try{
      if(mode === 'start' && !isVideoPlaying){
        await videoRef.current!.play()
      }
      if(mode === 'stop' && isVideoPlaying){
        videoRef.current!.pause()
        videoRef.current!.load()
        videoRef.current!.changeCurrentTime(0)
      }
    } catch {
      console.log('your video could not be played')
    }
  },[isVideoPlaying])

  useEffect(() => {
    if(isGalleryMode && !isVideoPlaying){
      handleVideo('start')
      setIsVideoPlaying(true)
    } else if(!isGalleryMode) {
      handleVideo('stop')
      setIsVideoPlaying(false)
    }
  }, [isGalleryMode, isVideoPlaying, handleVideo, setIsVideoPlaying])

  return (
    <AspectRatio
      w="100%"
      h="100%"
      maxH={(height && height - 100) ?? HEIGHT}
      maxW={1300}
      sx={{
        '.video-react': {
          border: '5px solid white'
        },
        '.video-react-fullscreen-control': {
          display: 'none',
        },
        '.video-react-big-play-button': {
          display: 'none'
        },
        '.video-react-control-bar': {
          display: 'flex'
        }
      }}
    >
      <Player
        ref={videoRef}
        preload="metadata"
        src={media}
        fluid={false}
        aspectRatio="16:9"
        width="100%"
        height="100%"
      >
        <ControlBar autoHide={false} className="my-class">
        </ControlBar>
      </Player>
    </AspectRatio>
  )
}

export { Video }
